import {
  AB_CARDS_3_4_CLASS,
  DEFAULT_CARDS,
  COURSES_CARDS,
  SUBJECTS_CARDS,
  prices,
  PriceType,
} from './constants';

export const getCards = (
  isCourses: boolean = false,
  isSubscription: boolean = false,
  isSubjects: boolean = false,
  courseParallel: string = '1-2',
) => {
  if (isCourses) {
    return COURSES_CARDS.filter((card) => card.courseParallel === courseParallel);
  }
  if (isSubjects) {
    return SUBJECTS_CARDS;
  }
  if (isSubscription) {
    if (courseParallel === '1-2') return DEFAULT_CARDS;
    return AB_CARDS_3_4_CLASS;
  }
  return DEFAULT_CARDS;
};

export const getPrice = (isCourses: boolean = false, isSubjects: boolean = false) => {
  if (isCourses) {
    return prices[PriceType.COURSES];
  }
  if (isSubjects) {
    return prices[PriceType.SUBJECTS];
  }
  return prices[PriceType.DEFAULT];
};
